import { render, staticRenderFns } from "./CreateContactModal.vue?vue&type=template&id=6a704385&scoped=true&"
import script from "./CreateContactModal.vue?vue&type=script&lang=js&"
export * from "./CreateContactModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateContactModal.vue?vue&type=style&index=0&id=6a704385&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a704385",
  null
  
)

export default component.exports